/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */
var _ = require('underscore');
var momentUtil = require('common/util/momentUtil');

module.exports = function(formData) {
  var defer = $.Deferred();
  var DATE_FMT = 'MM/DD/YYYY';
  var DATETIME_FMT = 'MM/DD/YYYY hh:mm A';

  function formatDate(value) {
    return momentUtil.formatStr(value, _.extend({}, momentUtil.defaultOutboundDateConfig, { sourceFormat: DATE_FMT }));
  }

  function formatDateTimeFromParts(date, time) {
    var combined = (date || '') + ' ' + (time || '');
    combined = combined.replace(/^\s+|\s+$/g, ''); // trim for ES5
    return momentUtil.formatStr(
      combined,
      _.extend({}, momentUtil.defaultOutboundDateTimeConfig, { sourceFormat: DATETIME_FMT })
    );
  }

  // datetimes
  var dateTimePairs = [
    ['examinerReviewedDate', 'examinerReviewedTime'],
    ['regionalDirectorReviewedDate', 'regionalDirectorReviewedTime']
  ];

  for (var i = 0; i < dateTimePairs.length; i++) {
    var dateKey = dateTimePairs[i][0];
    var timeKey = dateTimePairs[i][1];

    formData[dateKey] = formatDateTimeFromParts(formData[dateKey], formData[timeKey]);
  }

  // simple date fields
  var dateFields = [
    'examDate',
    'examCoverageStartDate',
    'examCoverageEndDate',
    'examStartDate',
    'examEndDate',
    'cancelledDate',
    'examTransmittalDate'
  ];

  for (var j = 0; j < dateFields.length; j++) {
    var key = dateFields[j];
    formData[key] = formatDate(formData[key]);
  }

  $.soap({
    body: {
      SubmitUpdateExamGeneralInformation: {
        $xmlns: 'http://dobs.pa.gov/nd/exam/bpm/1.0',
        ExamID: formData.examId,
        ExamDate: formData.examDate,
        ExamCoverageStartDate: formData.examCoverageStartDate,
        ExamCoverageEndDate: formData.examCoverageEndDate,
        RegionalDirectorReviewedDate: formData.regionalDirectorReviewedDate,
        ExaminerReviewedDate: formData.examinerReviewedDate,
        ExamStartDate: formData.examStartDate,
        ExamEndDate: formData.examEndDate,
        CancelledDate: formData.cancelledDate,
        ExamTransmittalDate: formData.examTransmittalDate
      }
    }
  })
    .done(function() {
      defer.resolve();
    })
    .fail(function(err) {
      defer.reject(err);
    });
  return defer.promise();
};
